import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Utils
import { getIsAuthenticated } from '../../utils/user';

// Constants
import ROUTE from '../../constants/route-constants';

import Loader from '../Loader';

type ProtectedRouteProps = {
  children: React.ReactNode,
  isAuthenticated: boolean,
  isUserAvailable: boolean,
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, isAuthenticated, isUserAvailable }: any) => {
  const location = useLocation();

  if (isAuthenticated && !isUserAvailable) return <Loader />;

  if ((isAuthenticated || getIsAuthenticated()) && isUserAvailable) return children;

  return <Navigate to={ROUTE.AUTH_SIGN_IN} state={{ from: location }} replace />;
};

export default ProtectedRoute;
